/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.inner = this.querySelector('.max-height--inner');
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      this.inner.addEventListener('transitionend', this.onTransitionEnd.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));


      this.checkVisible();
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      if (this.reducedMotion.matches) {
        this.classList.toggle('max-height--enabled');
        return;
      }

      if (this.classList.contains('max-height--enabled')) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    /* Animates max-height from the limit to the measured text height; onTransitionEnd then releases it to none. */
    expand() {
      this.inner.style.maxHeight = `${this.inner.scrollHeight}px`;
      this.classList.add('max-height--enabled');
    }

    /* Pins max-height to the current height so the transition back to the limit has a numeric start value. */
    collapse() {
      this.inner.style.maxHeight = `${this.inner.offsetHeight}px`;
      this.inner.offsetHeight;
      this.inner.style.maxHeight = '';
      this.classList.remove('max-height--enabled');
    }

    onTransitionEnd(event) {
      if (event.target !== this.inner || event.propertyName !== 'max-height') {
        return;
      }

      if (this.classList.contains('max-height--enabled')) {
        this.inner.style.maxHeight = '';
      }
    }
  }
  customElements.define('max-height', MaxHeight);
}
